export default {
  name: '',
  isAdmin: false,
  getProfileError: ''
}



// WEBPACK FOOTER //
// ./src/store/modules/profile/state.js